import { forEach } from 'lodash';
import {
  NumericDataEntity,
  NumericDataType
} from './../../../../../models/data-entities/numeric-data-entity';
import { Component, OnInit, ComponentFactoryResolver, Input, ChangeDetectorRef } from '@angular/core';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-numeric-data-entity-input',
    templateUrl: './numeric-data-entity-input.component.html',
    styleUrls: ['./numeric-data-entity-input.component.css'],
    standalone: false
})
export class NumericDataEntityInputComponent extends DataEntityInputComponent
  implements OnInit {
  numericDE: NumericDataEntity;
  NumericDataType = NumericDataType;
  templateForPermitForm: boolean = false;         // Added by Vipul on 23/12/2025
  stepValue: any;                                  // Added by Vipul on 26/12/2025
  @Input() showLabel = true;
  @Input() orientation: 'horizontal' | 'vertical' = 'vertical';

  constructor(public layoutService: LayoutService, componentFactory: ComponentFactoryResolver, ref: ChangeDetectorRef, context : WorkflowContextService) {
    super(layoutService, componentFactory, ref, context);
    // Started by Vipul on 23/12/2025
   layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 23/12/2025
  }

  ngOnInit() {
    this.numericDE = this.entity as NumericDataEntity;
    this.setStep(this.numericDE.decimalPlaces); // Added by Vipul on 26/12/2025
    if (
      !this.entity.externalDataSource ||
      !this.entity.externalDataSource.sourceConfig ||
      (this.entity.canEditExternalValue &&
        this.form.controls[this.entity.templateCode])
    ) {
      this.form.controls[this.entity.templateCode].enable();
    } else {
      this.form.controls[this.entity.templateCode].disable();
    }
  }

  incrementValue() {
    const formControl = this.form.controls[this.entity.templateCode];
    if (!formControl || formControl.disabled) return;

    let currentValue = parseFloat(this.entity.value) || 0;
    const step = this.getStepValue();
    const newValue = currentValue + step;

    if (this.numericDE.maximumValue !== null && this.numericDE.maximumValue !== undefined) {
      if (newValue <= this.numericDE.maximumValue) {
        this.updateValue(newValue);
      }
    } else {
      this.updateValue(newValue);
    }
  }

  decrementValue() {
    const formControl = this.form.controls[this.entity.templateCode];
    if (!formControl || formControl.disabled) return;

    let currentValue = parseFloat(this.entity.value) || 0;
    const step = this.getStepValue();
    const newValue = currentValue - step;

    if (this.numericDE.minimumValue !== null && this.numericDE.minimumValue !== undefined) {
      if (newValue >= this.numericDE.minimumValue) {
        this.updateValue(newValue);
      }
    } else {
      this.updateValue(newValue);
    }
  }

  private getStepValue(): number {
    if (this.numericDE.decimalPlaces > 0) {
      return parseFloat('0.' + '0'.repeat(this.numericDE.decimalPlaces - 1) + '1');
    }
    return 1;
  }

  private updateValue(value: number) {
    const formattedValue = this.numericDE.decimalPlaces > 0
      ? value.toFixed(this.numericDE.decimalPlaces)
      : value.toString();

    this.entity.value = formattedValue;
    this.form.controls[this.entity.templateCode].setValue(formattedValue);
    this.form.controls[this.entity.templateCode].markAsDirty();
  }

  onKeyDown(event: KeyboardEvent) {
    const formControl = this.form.controls[this.entity.templateCode];
    if (!formControl || formControl.disabled) return;

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.incrementValue();
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.decrementValue();
    }
  }

  // Started by Vipul on 26/12/2025
  setStep(decimalPlaces: number) {
    this.stepValue = Math.pow(10, -decimalPlaces);
  }
  // End by Vipul on 26/12/2025
}
